import { useMutation, useQuery, useQueryClient } from "react-query";
import superuserService from "@/services/superadminService";
import shipService from "@/services/shipService";
import { getSynedTable } from "@/services/syncService";

export const useAllShiptypes = () => {
  return useQuery({
    queryKey: ["viewAllShiptype"],
    queryFn: superuserService.viewAllShiptype,
  });
};

export const useViewAllOwners = () => {
  return useQuery({
    queryKey: ["viewownerlist"],
    queryFn: superuserService.viewAllOwners,
  });
};

//FOR POST METHOD
export const useCreateShiptype = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => superuserService.createShipType(payload), // Accept input data
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["create_shiptype"] });
    },
    onError: (error) => {
      console.error("Error creating owner group:", error);
    },
  });
};

export const useCreateOwner = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => superuserService.createOwner(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["createowner"] });
    },
    onError: (error) => {
      console.error("Error creating owner group:", error);
    },
  });
};

export const useViewModulegroups = (activeTab) => {
  return useQuery({
    queryKey: ["viewmodulegroups"],
    queryFn: superuserService.viewallmodulegroup,
    enabled: activeTab
      ? activeTab === "module_assigning"
        ? true
        : false
      : true,
  });
};

export const useCreatemodulegroup = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload) => superuserService.createmodulegroup(payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["createmodulegroup"] });
    },
    onError: (error) => {
      console.error("Error creating owner group:", error);
    },
  });
};

export const useSyncTablerecords = () => {
  return useQuery({
    queryKey: ["synctable"],
    queryFn: getSynedTable,
  });
};

 
// datasources/superadmin-query.js
export const useAllModules = ({ enabled = true } = {}) => {
  return useQuery({
    queryKey: ["getallmodules"],
    queryFn: superuserService.getallModules,
    enabled, // ✅ React Query won't fire the request if false
  });
};

export const useFetchAllShips = () => {
  return useQuery({
    queryKey: ["useFetchAllShips"],
    queryFn: shipService.getShips,
  });
};